import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface CompanyFieldProps {
  control: Control<FormProps>;
}

export function CompanyField({ control }: Readonly<CompanyFieldProps>) {
  return (
    <Controller
      name="company"
      control={control}
      rules={{ required: 'required' }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label="Company"
          required
          fullWidth
          autoComplete="organization"
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
